import React from "react";
import { AIChart } from "./AIChart";

/**
 * @param {Object} props
 * @param {Object[]} props.specs
 * @returns {React.ReactNode}
 */
const AICharts = ({ specs = [] }) => {
  return specs.map((spec, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <AIChart key={i} spec={spec} />
  ));
};

export default AICharts;
